import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { getShiftDays, onTimeChange } from '../../../../utils/utils.common'
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { start } from 'repl';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { OnboardingMenu } from 'src/app/enums/enums';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
@UntilDestroy()

@Component({
  selector: 'app-add-fare',
  templateUrl: './add-fare.component.html',
  styleUrls: ['./add-fare.component.css']
})
export class AddFareComponent implements OnInit {
  spacetypes: any;
  search: any;
  levelOfServices: any;
  prelevelOfServices: any = {};
  fareForm!: FormGroup
  zoneFareForm!: FormGroup;
  days = getShiftDays;
  selectedDays: any = [];
  singleZoneFormSubmitted = false;
  selectedSpaceType: any = null;
  submitted = false;
  companyId: any;
  fareId: any;
  minEndTime: any;
  fundingSourceId: any
  user: any;
  timeZone: any;
  selectedRoute: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private credentialService: CredentialService,
    private configurationService: ConfigurationService,
    private fundingSourceService: FundingSourceService,
    private spaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder) {

  }

  ngOnInit() {

    this.fareId = this.route.snapshot.params['fareId'];
    this.fundingSourceId = this.route.snapshot.params['fundingSourceId'];
    this.companyId = this.route.snapshot.params['companyId'];


    if (this.companyId) {
      this.getCompanyById();
    }
    if (this.fundingSourceId) {
      this.getFundingSourceById();
    }
    
    this.getLevelOfService();

    this.fareForm = this.fb.group({
      type: ['fixed'],
      name: ['', Validators.required],
      zones: this.fb.array([]),
      pickupSurcharge: this.fb.group({
        fare: [0],
        per: [0],
        after: [0]
      }),
      baseFare: this.fb.group({
        fare: [0, Validators.required],
        for: [0]
      }),
      waitTime: this.fb.group({
        fare: [0],
        per: [0],
        after: [0]
      }),
      startTime: [moment().startOf('day'), Validators.required],
      endTime: [moment().endOf('day'), Validators.required],
      days: [[], Validators.required],
      isPerMileZone: [false], // Boolean
      // zones: [[]],

      perMile: [0],
      perMin: [0],

      weekendNightCode: [''],
      nightCode: [''],

      // minimumFare: ['0'],
      cancelCharges: this.fb.group({
        type: ['fixed'],
        value: [0, Validators.required],
      }),
      noShowCharges: this.fb.group({
        type: ['fixed'],
        value: [0, Validators.required],
      }),
      additionalPassengerCharges: ['0'],
      company: [''],
      fundingsource: [''],
      los: [''],
      spaceType: ['', Validators.required],
      perMileCode: [''],
      dryRunCode: [''],
      baseFareCode: [''],
      waitTimeCode: [''],
      isActive: [true, Validators.required]

    });

    // this.zoneFareForm = this.fb.group({
    //   fare: [0],
    //   baseFare: [0],
    //   from: [''],
    //   to: ['']
    // });



    this.fareForm.get('type')?.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((tab) => {
        this.setValidations(tab);
        if (tab === 'percentage') {
          this.fareForm.get('cancelCharges')?.patchValue({ type: 'percentage', value: 0 });
          this.fareForm.get('noShowCharges')?.patchValue({ type: 'percentage', value: 0 });
        } else {
          this.fareForm.get('cancelCharges')?.patchValue({ type: 'fixed', value: 0 });
          this.fareForm.get('noShowCharges')?.patchValue({ type: 'fixed', value: 0 });
        }
      });
    this.setValidations('fixed');
    this.getUser();

  }

  getCompanyById() {
    this.credentialService
      .getPicker({id: this.companyId, isActive: true, limit: 9999 })
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          [this.selectedRoute] = data.results;
        }
      });
  }
  getFundingSourceById() {
    this.fundingSourceService.getById(this.fundingSourceId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.selectedRoute = data;
      }
    });
  }

  setValidations(tab: string) {
    const keys = ['baseFare.for', 'waitTime.fare', 'waitTime.per', 'waitTime.after', 'perMile', 'perMin'];
    const items = this.zonesFormArray;

    for (const key of keys) {
      const control = this.fareForm.get(key);
      if (tab === 'percentage') {
        control?.clearValidators();
        control?.setValue(0);
        this.fareForm.get('isPerMileZone')?.setValue(false);
        this.fareForm.get('pickupSurcharge')?.patchValue({ fare: 0, per: 0, after: 0 });
        items.controls.forEach((group: AbstractControl) => {
          const fareCtrl = (group as FormGroup).get('fare');
          fareCtrl?.setValue(0);
          fareCtrl?.clearValidators();
          fareCtrl?.updateValueAndValidity();
        });

      } else {
        control?.setValidators([Validators.required]);
        items.controls.forEach((group: AbstractControl) => {
          const fareCtrl = (group as FormGroup).get('fare');
          fareCtrl?.setValidators([Validators.required]);
          fareCtrl?.updateValueAndValidity();
        });
      }

      control?.updateValueAndValidity();
    }
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.timeZone;
        this.getSpaceType();
      }
    })
  }


  getSpaceType() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.spaceTypeService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.spacetypes = data.results;
        if (this.fareId) {
          this.getFareById();
        }
      }
    })
  }

  getLevelOfService() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.levelOfServices = data.results;
          this.prelevelOfServices = this.levelOfServices.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  convertToUTCISOString(date: any): string {
    return moment(date).utc(true).toISOString();
  }


  onSave() {
    this.submitted = true;
    const company = this.fundingSourceId ? null : this.companyId;
    const fundingsource = this.companyId ? null : this.fundingSourceId;
    this.fareForm.patchValue({
      days: this.selectedDays,
      company: company,
      fundingsource: fundingsource
    })

    if (!this.selectedSpaceType) {
      return;
    }
    if (this.fareForm.invalid) return;
    let payload = this.fareForm.value;
    payload.startTime = this.convertToUTCISOString(payload.startTime);
    payload.endTime = this.convertToUTCISOString(payload.endTime);
    this.credentialService.saveFare(this.fareId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.fundingSourceId) {
          this.router.navigate([`/funding-sources/${this.fundingSourceId}/fare`]);
        } else if (this.companyId) {
          this.router.navigate(['/credentials', this.companyId], { fragment: OnboardingMenu.RATES });
        } else {
          console.log('Both fundingSourceId and companyId are undefined');
        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    )
  }


  addZone(preZoneList?: any[]) {
    const items = this.zonesFormArray;

    if (preZoneList?.length) {
      for (const zone of preZoneList) {
        items.push(this.fb.group({
          baseFare: [zone.baseFare, Validators.required],
          fare: [zone.fare],
          from: [zone.from, Validators.required],
          to: [zone.to, Validators.required],
        }));
      }
      return;
    }

    items.push(this.fb.group({
      baseFare: ['', Validators.required],
      fare: [''],
      from: ['', Validators.required],
      to: ['', Validators.required],
    }));
  }


  removeZone(index: number) {
    this.zonesFormArray.removeAt(index);
  }

  onToggleZonePerMile(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.fareForm.patchValue({
      isPerMileZone: isChecked,
    });
  }

  selectSpaceType(spacetype: any): void {
    this.selectedSpaceType = this.selectedSpaceType === spacetype ? null : spacetype;
    this.fareForm.patchValue({
      spaceType: this.selectedSpaceType.id,
      los: this.selectedSpaceType.los,
      name: spacetype?.title || ''
    })
  }
  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  convertUTCToCompanyTime(utcTime: string): moment.Moment {
    const formatted = moment.utc(utcTime).format("YYYY-MM-DDTHH:mm:ss");
    return moment.tz(formatted, "YYYY-MM-DDTHH:mm:ss", this.timeZone);
  }

  getFareById() {
    this.credentialService.getFareById(this.fareId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {

        const startTimeUTC = moment.utc(data.startTime).format("YYYY-MM-DDTHH:mm:ss");
        const endTimeUTC = moment.utc(data.endTime).format("YYYY-MM-DDTHH:mm:ss");

        this.fareForm.patchValue({
          ...data,
          startTime: this.convertUTCToCompanyTime(startTimeUTC),
          endTime: this.convertUTCToCompanyTime(endTimeUTC),
        });

          this.fareForm.get('noShowCharges')?.patchValue({
            type: data.noShowCharges.type,
            value: data.noShowCharges.value
          });

          this.fareForm.get('cancelCharges')?.patchValue({
            type: data.cancelCharges.type,
            value: data.cancelCharges.value
          });

        this.selectedDays = data.days;
        this.selectedSpaceType = this.spacetypes.find(
          (spacetype: any) => spacetype.id === data.spaceType
        );
        if (data.zones && data.zones.length) {
          this.addZone(data.zones);
        }
      }
    });
  }

  get form() {
    return this.fareForm.controls;
  }

  get baseFareFrom() {
    return this.fareForm.controls.baseFare as FormGroup
  }
  get cancelChargesForm() {
    return this.fareForm.controls.cancelCharges as FormGroup
  }
  get noShowChargesForm() {
    return this.fareForm.controls.noShowCharges as FormGroup
  }

  get zonesFormArray() {
    return this.fareForm.get('zones') as FormArray;
  }

  get waitForm() {
    return this.fareForm.controls.waitTime as FormGroup;
  }

  getTimeRestrictions() {
    return { min: moment(this.fareForm.value.startTime).startOf("day").toISOString(), max: moment(this.fareForm.value.endTime).endOf("day").toISOString() }
  }


}
